// libraries.
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '@store';

// types.
export type BusinessLine = 'Inmo' | 'Market-Maker' | null;

interface GeoreferencingState {
  selectedCoordinates: google.maps.LatLngLiteral | null;
  selectedNid: string | null;
  isLoadingCoordinates: boolean;
  selectedBusinessLine: BusinessLine;
}

const initialState: GeoreferencingState = {
  selectedCoordinates: null,
  selectedNid: null,
  isLoadingCoordinates: false,
  selectedBusinessLine: null,
};

export const domainGeoreferencingSlice = createSlice({
  name: 'domainGeoreferencing',
  initialState,
  reducers: {
    setSelectedCoordinates: (
      state,
      action: PayloadAction<{
        coordinates: google.maps.LatLngLiteral;
        nid: string;
      }>
    ) => {
      state.selectedCoordinates = action.payload.coordinates;
      state.selectedNid = action.payload.nid;
      state.isLoadingCoordinates = false;
    },
    updateCoordinates: (
      state,
      action: PayloadAction<google.maps.LatLngLiteral>
    ) => {
      state.selectedCoordinates = action.payload;
    },
    clearSelectedCoordinates: state => {
      state.selectedCoordinates = null;
      state.selectedNid = null;
      state.isLoadingCoordinates = false;
    },
    setLoadingCoordinates: (state, action: PayloadAction<boolean>) => {
      state.isLoadingCoordinates = action.payload;
    },
    setBusinessLine: (state, action: PayloadAction<BusinessLine>) => {
      state.selectedBusinessLine = action.payload;
    },
    resetCoordinates: state => {
      state.selectedCoordinates = null;
    },
    resetSearch: state => {
      state.selectedCoordinates = null;
      state.selectedNid = null;
      state.isLoadingCoordinates = false;
    },
    setDefaultState: () => {
      return initialState;
    },
  },
});

export const {
  setSelectedCoordinates,
  updateCoordinates,
  clearSelectedCoordinates,
  setLoadingCoordinates,
  setBusinessLine,
  resetCoordinates,
  resetSearch,
  setDefaultState,
} = domainGeoreferencingSlice.actions;

export default domainGeoreferencingSlice.reducer;

// selectors.
export const getSelectedCoordinates = (state: RootState) =>
  state.domainGeoreferencing.selectedCoordinates;

export const getSelectedNid = (state: RootState) =>
  state.domainGeoreferencing.selectedNid;

export const getIsLoadingCoordinates = (state: RootState) =>
  state.domainGeoreferencing.isLoadingCoordinates;

export const getSelectedBusinessLine = (state: RootState) =>
  state.domainGeoreferencing.selectedBusinessLine;
